
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30740',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30740",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55260",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8296",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11752",
  "I18n": "static-7.1667",
  "quartz": "static-1.7411",
  "quartz-config": "static-1.1189",
  "quartz-core": "static-1.6630",
  "react-dlb": "static-1.88",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.77",
  "reselect": "static-3.9",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.886",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55247",
  "feedback-utils": "static-1.55251",
  "forms-embed-utils-lib": "static-1.4731",
  "forms-utils-lib": "static-1.13050",
  "foundations-assets": "static-1.5148",
  "foundations-components": "static-1.8434",
  "foundations-theming": "static-1.4736",
  "hub-http": "static-1.6479",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12059",
  "icons": "static-2.677",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4109",
  "raven": "static-3.5925",
  "react": "static-7.192",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5534",
  "react-virtualized": "static-2.104",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.499",
  "tinymce-plugins": "static-1.58159",
  "transmute": "static-2.85",
  "ui-images": "static-2.1238",
  "UIComponents": "static-3.8698",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3596",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3688",
  "quartz-webpack": "static-1.3635",
  "foundations-theming-specialty": "static-1.2452",
  "property-description-translator": "static-1.4107",
  "HeadJS": "static-2.793",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3407",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.229",
  "moment-timezone": "static-5.88",
  "jasmine": "static-4.4580",
  "jasmine-runner": "static-1.6719",
  "opentelemetry-fe-types": "static-1.35",
  "dispatcher": "static-1.142",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.873",
  "hubspotter-http": "static-1.4842",
  "mobile-manifest-mixins": "static-1.573",
  "module-federation": "static-1.30",
  "opentelemetry-fe": "static-1.410",
  "quartz-auth": "static-1.1086",
  "quartz-head": "static-1.1076",
  "quartz-i18n": "static-1.1086",
  "quartz-routing": "static-1.841",
  "quartz-test": "static-1.1086",
  "quartz-tracking": "static-1.790",
  "trellis-components": "static-1.2563",
  "ui-fonts": "static-1.1014",
  "usage-tracker-container": "static-1.7612",
  "usage-tracker-core": "static-1.7472",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.163",
  "conversations-skeleton-state": "static-1.7512",
  "reference-resolvers": "static-1.8449",
  "sanitize-text": "static-1.8419",
  "PatternValidationJS": "static-1.3161",
  "ReduxMessenger": "static-2.10636",
  "outpost": "static-1.4424",
  "rpc-client-utils": "static-1.4931",
  "sanitize": "static-1.4740",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4703",
  "floating-ui": "static-1.62",
  "hs-story-utils": "static-1.9693",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.66",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2544",
  "bend-plugin-foundations-theming": "static-1.3219",
  "foundations-theming-base": "static-1.3721",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.270",
  "csstype": "static-1.50",
  "web-vitals": "static-1.12",
  "ai-components-ui-library": "static-1.9645",
  "atom": "static-1.5352",
  "codemirror": "static-5.99",
  "content-assistance-lib": "static-1.8156",
  "ContentUtils": "static-1.69066",
  "data-token-picker": "static-1.16842",
  "file-manager-components": "static-1.24414",
  "FileManagerCore": "static-1.39913",
  "FileManagerLib": "static-1.40054",
  "frontend-preferences-client": "static-1.8190",
  "hub-http-contrib": "static-1.3305",
  "interframe": "static-3.5022",
  "layout-dnd-components": "static-1.12918",
  "layout-dnd-utils": "static-1.11893",
  "property-translator": "static-1.5664",
  "react-codemirror": "static-1.10905",
  "react-colorpicker": "static-2.10474",
  "reference-resolvers-lite": "static-1.8369",
  "rich-text-lib": "static-1.20261",
  "tinymce-data": "static-1.41130",
  "tinymce-themes": "static-1.57015",
  "ui-addon-emoji-picker": "static-1.10152",
  "ui-addon-sales-email": "static-1.5479",
  "ui-brand-identity-lib": "static-1.16342",
  "bender-build-tools": "static-1.3411",
  "opentelemetry-web": "static-1.11",
  "hub-http-shared-msw-handlers": "static-1.10563",
  "hubspotter-http-shared-msw-handlers": "static-1.10561",
  "usage-tracker-session-replay": "static-1.5308",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1235",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.341",
  "chirp-fetch": "static-1.2160",
  "chatspot-core": "static-1.22772",
  "copilot-toolkit": "static-1.11789",
  "customer-data-objects-ui-components": "static-1.13297",
  "data-fetching-client": "static-1.9924",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5024",
  "ui-addon-video-player": "static-1.8968",
  "ui-coaching-tips": "static-1.29251",
  "usage-tracker": "static-1.7622",
  "cms-field-types": "static-1.5080",
  "content-icons-ui": "static-1.2329",
  "integrations-lib": "static-1.16971",
  "customer-data-objects": "static-1.7953",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1630",
  "apollo-link-hub-http": "static-2.4922",
  "apollo-stack-hubspot": "static-3.91",
  "graphql": "static-1.86",
  "immer": "static-1.94",
  "immerable": "static-1.4417",
  "ui-addon-iframeable": "static-1.9342",
  "video-components-external": "static-1.12097",
  "video-data-lib": "static-1.35755",
  "breeze-artifacts-sdk": "static-1.245",
  "audio-components": "static-1.6297",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29764",
  "FileManagerImages": "static-1.37565",
  "foundations-components-legacy": "static-1.1459",
  "html-to-image": "static-1.58",
  "redux-toolkit": "static-1.75",
  "salesImages": "static-1.532",
  "ui-universal-auth": "static-1.9338",
  "urlinator": "static-1.4799",
  "video-components": "static-1.14099",
  "video-embed": "static-1.36589",
  "ts-schema": "static-1.4271",
  "ContentData": "static-1.69141",
  "layout-data-lib": "static-1.10218",
  "react-dnd-compat": "static-1.4883",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1809",
  "external-options-client-types": "static-1.4317",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7158",
  "hs-promise-utils": "static-1.5863",
  "inbound-db-properties-service-client": "static-1.4034",
  "NamespacedHubStyle": "static-2.9240",
  "growth-onboarding-confetti": "static-1.3329",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11412",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5732",
  "magpie-types": "static-1.5192",
  "simple-logging-lib": "static-1.3317",
  "avatar-components": "static-1.2760",
  "customer-data-ui-utilities": "static-1.10095",
  "growth-onboarding-feedback-components": "static-1.6850",
  "flux-actions": "static-1.364",
  "hubspot-apollo-client": "static-1.5145",
  "integrations-error-boundary-lib": "static-1.14386",
  "integrations-tracking-lib": "static-1.5874",
  "laboratory-lib": "static-3.7418",
  "native-integrations-shared-strings": "static-1.8045",
  "redux-observable": "static-1.72",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10534",
  "unified-auth": "static-1.852",
  "breeze-engine-chat-components": "static-1.608",
  "breeze-engine-core": "static-1.908",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "navigation-messaging": "static-1.8083",
  "content-media-composition-data-lib": "static-1.13172",
  "content-media-compositions": "static-2.17179",
  "idb-keyval": "static-1.48",
  "media-bridge-lib": "static-1.19362",
  "unified-auth-core-lib": "static-1.1134",
  "social-insights-client-types": "static-1.22685",
  "advanced-menus-core": "static-1.15533",
  "advanced-menus-lib": "static-1.12411",
  "ExportDialog": "static-6.10645",
  "ui-memberships-settings-lib": "static-1.34783",
  "conditional-properties-service-client": "static-1.3989",
  "crm-pipelines-api-client-types": "static-1.4325",
  "fdsr-migration-layer": "static-1.277",
  "framework-builder-read-service-client": "static-1.4199",
  "framework-data-schema-quick-fetch": "static-1.7063",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3886",
  "persist-promise": "static-1.3966",
  "foundations-components-test-utils": "static-1.5917",
  "reactive-lib": "static-1.986",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.604",
  "universal-page-editor-lib": "static-1.3274",
  "adobe-sign-auth-lib": "static-1.399",
  "ads-unified-auth-lib": "static-1.1191",
  "google-sheets-integration-lib": "static-1.970",
  "microsoft-drive-auth-lib": "static-1.68",
  "surveymonkey-integration-lib": "static-1.415",
  "slack-ui-library": "static-1.10664",
  "js-cookie": "static-1.18",
  "fsm": "static-1.4011",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15532",
  "simple-menus-lib": "static-1.17049",
  "crm-record-cards-service-types": "static-1.3762",
  "location-customization-utils-lib": "static-1.10034",
  "react-flip-move": "static-1.75"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30740",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55260",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8296",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11752",
  "I18n": "/I18n/static-7.1667",
  "quartz": "/quartz/static-1.7411",
  "quartz-config": "/quartz-config/static-1.1189",
  "quartz-core": "/quartz-core/static-1.6630",
  "react-dlb": "/react-dlb/static-1.88",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reselect": "/reselect/static-3.9",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.886",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55247",
  "feedback-utils": "/feedback-utils/static-1.55251",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4731",
  "forms-utils-lib": "/forms-utils-lib/static-1.13050",
  "foundations-assets": "/foundations-assets/static-1.5148",
  "foundations-components": "/foundations-components/static-1.8434",
  "foundations-theming": "/foundations-theming/static-1.4736",
  "hub-http": "/hub-http/static-1.6479",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12059",
  "icons": "/icons/static-2.677",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4109",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.192",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-fkhalid-delete-fcp-cls-subscribers.4",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5534",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.499",
  "tinymce-plugins": "/tinymce-plugins/static-1.58159",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1238",
  "UIComponents": "/UIComponents/static-3.8698",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3596",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3688",
  "quartz-webpack": "/quartz-webpack/static-1.3635",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2452",
  "property-description-translator": "/property-description-translator/static-1.4107",
  "HeadJS": "/HeadJS/static-2.793",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3407",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.229",
  "moment-timezone": "/moment-timezone/static-5.88",
  "jasmine": "/jasmine/static-4.4580",
  "jasmine-runner": "/jasmine-runner/static-1.6719",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.35",
  "dispatcher": "/dispatcher/static-1.142",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.873",
  "hubspotter-http": "/hubspotter-http/static-1.4842",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.573",
  "module-federation": "/module-federation/static-1.30",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.410",
  "quartz-auth": "/quartz-auth/static-1.1086",
  "quartz-head": "/quartz-head/static-1.1076",
  "quartz-i18n": "/quartz-i18n/static-1.1086",
  "quartz-routing": "/quartz-routing/static-1.841",
  "quartz-test": "/quartz-test/static-1.1086",
  "quartz-tracking": "/quartz-tracking/static-1.790",
  "trellis-components": "/trellis-components/static-1.2563",
  "ui-fonts": "/ui-fonts/static-1.1014",
  "usage-tracker-container": "/usage-tracker-container/static-1.7612",
  "usage-tracker-core": "/usage-tracker-core/static-1.7472",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.163",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7512",
  "reference-resolvers": "/reference-resolvers/static-1.8449",
  "sanitize-text": "/sanitize-text/static-1.8419",
  "PatternValidationJS": "/PatternValidationJS/static-1.3161",
  "ReduxMessenger": "/ReduxMessenger/static-2.10636",
  "outpost": "/outpost/static-1.4424",
  "rpc-client-utils": "/rpc-client-utils/static-1.4931",
  "sanitize": "/sanitize/static-1.4740",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4703",
  "floating-ui": "/floating-ui/static-1.62",
  "hs-story-utils": "/hs-story-utils/static-1.9693",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.66",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2544",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3219",
  "foundations-theming-base": "/foundations-theming-base/static-1.3721",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.270",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.12",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9645",
  "atom": "/atom/static-1.5352",
  "codemirror": "/codemirror/static-5.99",
  "content-assistance-lib": "/content-assistance-lib/static-1.8156",
  "ContentUtils": "/ContentUtils/static-1.69066",
  "data-token-picker": "/data-token-picker/static-1.16842",
  "file-manager-components": "/file-manager-components/static-1.24414",
  "FileManagerCore": "/FileManagerCore/static-1.39913",
  "FileManagerLib": "/FileManagerLib/static-1.40054",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8190",
  "hub-http-contrib": "/hub-http-contrib/static-1.3305",
  "interframe": "/interframe/static-3.5022",
  "layout-dnd-components": "/layout-dnd-components/static-1.12918",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11893",
  "property-translator": "/property-translator/static-1.5664",
  "react-codemirror": "/react-codemirror/static-1.10905",
  "react-colorpicker": "/react-colorpicker/static-2.10474",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8369",
  "rich-text-lib": "/rich-text-lib/static-1.20261",
  "tinymce-data": "/tinymce-data/static-1.41130",
  "tinymce-themes": "/tinymce-themes/static-1.57015",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10152",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5479",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16342",
  "bender-build-tools": "/bender-build-tools/static-1.3411",
  "opentelemetry-web": "/opentelemetry-web/static-1.11",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10563",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10561",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5308",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1235",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.341",
  "chirp-fetch": "/chirp-fetch/static-1.2160",
  "chatspot-core": "/chatspot-core/static-1.22772",
  "copilot-toolkit": "/copilot-toolkit/static-1.11789",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13297",
  "data-fetching-client": "/data-fetching-client/static-1.9924",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5024",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8968",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29251",
  "usage-tracker": "/usage-tracker/static-1.7622",
  "cms-field-types": "/cms-field-types/static-1.5080",
  "content-icons-ui": "/content-icons-ui/static-1.2329",
  "integrations-lib": "/integrations-lib/static-1.16971",
  "customer-data-objects": "/customer-data-objects/static-1.7953",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1630",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4922",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.91",
  "graphql": "/graphql/static-1.86",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4417",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9342",
  "video-components-external": "/video-components-external/static-1.12097",
  "video-data-lib": "/video-data-lib/static-1.35755",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.245",
  "audio-components": "/audio-components/static-1.6297",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29764",
  "FileManagerImages": "/FileManagerImages/static-1.37565",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1459",
  "html-to-image": "/html-to-image/static-1.58",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "salesImages": "/salesImages/static-1.532",
  "ui-universal-auth": "/ui-universal-auth/static-1.9338",
  "urlinator": "/urlinator/static-1.4799",
  "video-components": "/video-components/static-1.14099",
  "video-embed": "/video-embed/static-1.36589",
  "ts-schema": "/ts-schema/static-1.4271",
  "ContentData": "/ContentData/static-1.69141",
  "layout-data-lib": "/layout-data-lib/static-1.10218",
  "react-dnd-compat": "/react-dnd-compat/static-1.4883",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1809",
  "external-options-client-types": "/external-options-client-types/static-1.4317",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7158",
  "hs-promise-utils": "/hs-promise-utils/static-1.5863",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4034",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9240",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3329",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11412",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5732",
  "magpie-types": "/magpie-types/static-1.5192",
  "simple-logging-lib": "/simple-logging-lib/static-1.3317",
  "avatar-components": "/avatar-components/static-1.2760",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10095",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6850",
  "flux-actions": "/flux-actions/static-1.364",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5145",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14386",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5874",
  "laboratory-lib": "/laboratory-lib/static-3.7418",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8045",
  "redux-observable": "/redux-observable/static-1.72",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10534",
  "unified-auth": "/unified-auth/static-1.852",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.608",
  "breeze-engine-core": "/breeze-engine-core/static-1.908",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "navigation-messaging": "/navigation-messaging/static-1.8083",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13172",
  "content-media-compositions": "/content-media-compositions/static-2.17179",
  "idb-keyval": "/idb-keyval/static-1.48",
  "media-bridge-lib": "/media-bridge-lib/static-1.19362",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1134",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15533",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12411",
  "ExportDialog": "/ExportDialog/static-6.10645",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34783",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3989",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4325",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.277",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4199",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7063",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3886",
  "persist-promise": "/persist-promise/static-1.3966",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5917",
  "reactive-lib": "/reactive-lib/static-1.986",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.604",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3274",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.399",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1191",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.970",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.68",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.415",
  "slack-ui-library": "/slack-ui-library/static-1.10664",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.4011",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15532",
  "simple-menus-lib": "/simple-menus-lib/static-1.17049",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3762",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10034",
  "react-flip-move": "/react-flip-move/static-1.75"
}
};
